import { apiSlice } from "../api/apiSlice";

export const assignmentsMarkApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAssignmentsMark: builder.query({
      query: ({ student_id, assignment_id }) => ({
        url: `/assignmentMark/?student_id=${student_id}&assignment_id=${assignment_id}`,
        method: "GET",
      }),
      providesTags: ["Assignmentmark"],
    }),
    getAllAssignmentMark: builder.query({
      query: () => ({
        url: "/assignmentmark",
        method: "GET",
      }),
      providesTags: ["Assignmentmark"],
    }),
    editAssignmentMark: builder.mutation({
      query: ({ id, data }) => ({
        url: `/assignmentmark/${id}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: (result, error, arg) => ["Assignmentmark"],
    }),
    submitAssignment: builder.mutation({
      query: (data) => ({
        url: "/assignmentmark",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["Assignmentmark"],
    }),
  }),
});

export const {
  useGetAssignmentsMarkQuery,
  useGetAllAssignmentMarkQuery,
  useEditAssignmentMarkMutation,
  useSubmitAssignmentMutation,
} = assignmentsMarkApi;
